<div class="widget-container" #funnelChartDiv>
    <app-funnel-chart
    [headerConfig]="this.item?.config?.widget_header_config || this.item?.config?.widget_header_configuration"
    style="width: 100%;"
    [config]="config"
    [heading]="heading"
    [data]="data"
    [item]="item"
    [pageKey]="pageKey"
    [error_name]="error_name"
    >
    </app-funnel-chart>
</div>
